export interface ISaveSuccessItems {
    message: string;
    ids: string[];
    rowIds: string[];
}

export class SaveSuccessItems implements ISaveSuccessItems {
    message: string;
    ids: string[];
    rowIds: string[];

    constructor();
    constructor(obj: ISaveSuccessItems);
    constructor(obj?: any) {
        this.message = obj && obj.message || "";
        this.ids = obj && obj.ids || [];
        this.rowIds = obj && obj.rowIds || [];
    }
}